import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_URL}/api/System`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
instance.interceptors.request.use(reqConfig => {
  if (Vue.prototype.$getCookie('comLoginToken')) {
    const xCorrelationId = Vue.prototype.$getGuid()
    reqConfig.headers = {
      KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
  }
  return reqConfig
}, err => {
  return Promise.reject(err)
})
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      if (err.response.data.Message !== undefined) {
        Vue.prototype.$alert(`${err.response.data.Message}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) { router.push({ name: 'LoginMain' }) } else if (err.response.status == 403) { Vue.prototype.$toMainPage() }
        })
        return Promise.reject(err)
      }
    // eslint-disable-next-line eqeqeq
    } else if (err && err.response && err.response.status == 404) {
      if (err.response.data.ErrorMessage.Description === '找不到指定系統公告') {
        Vue.prototype.$alert('此篇公告已下架', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          router.push({ name: 'SystemUpdates' })
        })
        return Promise.reject(err)
      }
    }
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/System
export const apiSystem = {
  // 取得系統公告列表
  GetSystemList: (requestData, config) => instance.get('/List', Object.assign({}, { params: requestData }, config)),
  // 取得系統公告內容
  GetSystemDetail: (requestData, config) => instance.get('/Detail', Object.assign({}, { params: requestData }, config))
}
